import React, { useEffect, useMemo, useState } from 'react';
import { getImageUrlCandidates } from '../../utils/imageUtils';

const UploadImagePreview = ({
  path,
  selectedFile,
  alt,
  className = '',
  fallback = null,
}) => {
  const [candidateIndex, setCandidateIndex] = useState(0);
  const [failed, setFailed] = useState(false);
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    setCandidateIndex(0);
    setFailed(false);
  }, [path, selectedFile]);

  useEffect(() => {
    if (!selectedFile) {
      setBlobUrl(null);
      return undefined;
    }

    const url = URL.createObjectURL(selectedFile);
    setBlobUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [selectedFile]);

  const candidates = useMemo(() => {
    if (blobUrl) return [blobUrl];
    return getImageUrlCandidates(path);
  }, [path, blobUrl]);

  if (failed || candidates.length === 0) {
    return fallback;
  }

  const src = candidates[candidateIndex];

  return (
    <img
      key={src}
      src={src}
      alt={alt}
      className={className}
      onError={() => {
        if (candidateIndex < candidates.length - 1) {
          setCandidateIndex((index) => index + 1);
        } else {
          setFailed(true);
        }
      }}
    />
  );
};

export default UploadImagePreview;
